module.exports = {
    basename: '/cvat-annotation',
};